import { Component } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJS from './../../../node_modules/crypto-js';
import { Ng2ImgToolsService } from 'ng2-img-tools';
import { SweetAlertService } from 'ng2-sweetalert2';
import { Observable } from 'rxjs/Observable';
@Component({
	selector: 'app-home',
	template: require('./home.component.html'),
	styles: [
		require('./home.component.css')
	],
	providers: [SweetAlertService]
})
// image upload taken from http://code.hootsuite.com/html5/
export class HomeComponent {
	private static MAX_WIDTH = 1536;
	private static MAX_HEIGHT = 1536;
	public images: Array<HTMLImageElement> = null;

	constructor(private router: Router, private swalService: SweetAlertService, private ng2ImgToolsService: Ng2ImgToolsService) {
	}
	selectImages(images: any) {
		let this$ = this;
		if (images !== null) {
			this.cropImagesModal(images.target.files.length);
			this.cropImages(images).then(data => {
				this$.uploadImagesModal();
			}).catch(error => {
				this$.swalService.swal({
					type: 'error',
					text: 'Ein Fehler ist während der Bildbearbeitung aufgetreten.'
				});
			});
		}
	}
	cropImages(images: any): Promise<any> {
		let this$ = this;
		this.images = [];
		return new Promise((resolve, reject) => {
			let lengthUploadQueue = images.target.files.length;
			let amount_images_uploaded = 0;
			for (let html_image of images.target.files)
			{
				let read_image: HTMLImageElement = new Image();
				let reader = new FileReader();

				read_image.onload = function () {
					if (html_image.type === 'image/jpeg' || html_image.type === 'image/jpg') {
						this$.ng2ImgToolsService.getEXIFOrientedImage(read_image).then(oriented_image => {
							this$.images.push(oriented_image);
							if (--lengthUploadQueue === 0) {
								resolve();
							}
						});
					} else {
						this$.images.push(read_image);
						if (--lengthUploadQueue === 0) {
							resolve();
						}
					}
					// this$.swalService.swal.content = '<div class="div-img-wait"></div><p>' +
					// amount_images_uploaded + ' von ' + images.target.files.length + ' Bildern verarbeitet.</p>';

				};
				reader.onloadend = function () {
					read_image.src = reader.result;
				};
				reader.readAsDataURL(html_image);
			}
		});
	}
	// resolves iff all images were uploaded; rejects otherwise
	uploadImages(): Promise<any> {
		return new Promise((resolve, reject) => {
			let lengthUploadQueue = this.images.length;
			this.images.forEach(image => {
				this.uploadImage(image).then(data => {
					if (--lengthUploadQueue === 0) {
						resolve();
					}
				}).catch(error => reject(error));
			});

		});
	}

	uploadImage(image: HTMLImageElement): Promise<any> {
		return new Promise((resolve, reject) => {
			if (image) {
				this.processFile(image.src, image.src.split(';')[0].split(':')[1]).then(data => resolve(data)).catch(error => reject(error));
			} else {
				reject('Es wurden keine Bilder ausgewählt.');
			}
		});
	}

	// scales image to MAX_WIDTH and MAX_HEIGHT
	processFile(base_encoding: string, type: any): Promise<any> {
		let scaledImage: HTMLImageElement = new Image();
		let this$ = this;

		scaledImage.src = base_encoding;
		let thisImage = scaledImage;
		return new Promise((resolve, reject) => {
			scaledImage.onload = function () {
				let width: number = scaledImage.width;
				let height: number = scaledImage.height;

				if (width > HomeComponent.MAX_WIDTH || height > HomeComponent.MAX_HEIGHT) {
					let scaledWidth: number = width;
					let scaledHeight: number = height;

					if (width > height) {
						scaledHeight = HomeComponent.MAX_HEIGHT;
						scaledWidth = width * (HomeComponent.MAX_HEIGHT / height);
					} else {
						scaledWidth = HomeComponent.MAX_WIDTH;
						scaledHeight = height * (HomeComponent.MAX_WIDTH / width);
					}

					let canvas = document.createElement('canvas');
					canvas.width = scaledWidth;
					canvas.height = scaledHeight;

					let context = canvas.getContext('2d');
					context.drawImage(thisImage, 0, 0, scaledWidth, scaledHeight);
					base_encoding = canvas.toDataURL(type);
				}
				this$.sendFile(base_encoding, type).then(data => resolve(data)).catch(error => reject(error));
			};
		});
	}

	uploadImagesModal() {
		let this$ = this;
		this.swalService.swal({
			title: 'Bilderupload',
			html: this$.generateModalHTML(),
			cancelButtonText: 'Abbrechen',
			showCancelButton: true,
			confirmButtonText: 'Hochladen',
			showLoaderOnConfirm: true,
			preConfirm: () => { return this$.uploadImages(); },
			allowOutsideClick: false
		}).then(() => {
			this$.images = null;
			this$.swalService.swal({
				type: 'success',
				title: 'Alle Ihre Bilder wurden hochgeladen.'
			});
		}, error => {
			if (error !== 'cancel' && error !== 'close' && error !== 'esc') {
				this$.swalService.swal({
					type: 'error',
					title: 'Fehler',
					text: error
				});
			} else {
				this$.images = null;
			}
		});
	}

	cropImagesModal(amount_images: number) {
		this.swalService.swal({
			title: 'Bitte warten',
			html: '<div class="div-img-wait"></div><p>' + amount_images + ' Bilder werden verarbeitet...</p>',
			showCancelButton: false,
			showConfirmButton: false,
		});
	}
	// html which shows image and its name
	generateModalHTML(): string {
		let html = '<h3>Ausgewählte Bilder</h3><div><a href="#down"><div class="down-button"><div class="down-arrows"></div></div></a>';
		if (this.images != null) {
			this.images.forEach(image => {
				html += '<div style="margin: 20px 0px;"><img src="' + image.src +
					'"></div>';
			});
			html += '<div id="down"></div>';
		} else {
			html = '<p>Es wurden keine Bilder ausgewählt.<p>';
		}
		return html;
	}

	sendFile(image: any, type: any): Promise<any> {
		return new Promise((resolve, reject) => {
			let xhr: XMLHttpRequest = new XMLHttpRequest();
			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					if (xhr.status === 200 || xhr.status === 204) {
						resolve(xhr.response);
					} else {
						reject(xhr.response);
					}
				}
			};
			xhr.onerror = (error) => {
				reject(error);
			};
			this.getUrl(type).then((response) => {
				let url = response;
				xhr.open('PUT', url, true);
				xhr.send(image);
			});
		});
	}

	getUrl(imageType: string): Promise<any> {
		let payload = {
			contentType: imageType,
			projectName: window.location.hostname.split('.')[0]
		};
		return new Promise((resolve, reject) => {
			let xhr: XMLHttpRequest = new XMLHttpRequest();
			xhr.onreadystatechange = () => {
				if (xhr.readyState === 4) {
					if (xhr.status === 200 || xhr.status === 204) {
						resolve(xhr.response);
					} else {
						reject(xhr.response);
					}
				}
			};
			xhr.onerror = (error) => {
				reject(error);
			};
			xhr.open('PUT', 'https://vddgb62wf2.execute-api.eu-central-1.amazonaws.com/prod/createsignedurl', true);
			xhr.send(JSON.stringify(payload));
		});
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/home/home.component.ts